import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
declare let isw: any;
import { StorageService } from "../../../core/helpers/storage-Service";
import { AuthService } from "../../../core/auth/auth.service";
import { PaymentService } from "../../shared/services/payment.service";
import { PaymentDetails } from "../../shared/models/paymentdetails";
import { Router, ActivatedRoute } from "@angular/router";
import { PaymentRequest } from "../../shared/models/makepaymentReq";
import { environment } from "../../../../environments/environment";

let iswResponseCode = { value: "00" };
let hasBeenLoaded = { value: 0 };
let loadingMessage = "Setting Payment Page...";

@Component({
    selector: "app-payment",
    templateUrl: "./payment.component.html",
    styleUrls: ["./payment.component.css"],
    standalone: false
})
export class PaymentComponent implements OnInit {
  title = "checkout-page";
  payWithCard: boolean = true;
  payWithBank: boolean = false;
  randomNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  GA_paymentResponse = iswResponseCode;
  checkIfPageIsLoadedPreviously = hasBeenLoaded;
  // paymentDetails: PaymentDetails;
  @Input() paymentDetails: PaymentDetails;
  @Output() isMakingPayment = new EventEmitter();
  paymentStatus = ["CREATED", "ONGOING", "ABANDONED", "FAILED", "SUCCESS"];
  message: string = "";
  timeSpent: number = 0;
  cardpaymentreq = new PaymentRequest();
  refereshLink: string;
  constructor(
    private storage: StorageService,
    private auth: AuthService,
    private payservice: PaymentService,
    private route: Router,
    private router: ActivatedRoute
  ) {
    this.refereshLink = this.router.snapshot.params["payRef"];
  }

  ngOnInit() {
    if (this.checkIfPageIsLoadedPreviously.value != 0) {
      document.getElementById("main").style.display = "none";
      document.getElementById("isStatusCheck").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      this.checkIfPageIsLoadedPreviously.value = 1;
      location.reload();
      return;
    }
    this.GA_paymentResponse.value = "Transaction ongoing";
    this.randomNumbers = this.shuffle(this.randomNumbers);
    this.setPaymentDetails(this.paymentDetails);
    this.getPaymentDetails();
    document.getElementById("isStatusCheck").style.display = "none";
    document.getElementById("noCardOption").style.display = "none";
    this.checkIfPageIsLoadedPreviously.value;
    //
    // this.loadScripts();
    // this.getAccessToken();
    // if (
    //   this.configuration.paymentParameters.amount != this.paymentDetails.amount
    // ) {
    // }
  }

  refreshPage() {
    this.randomNumbers = this.shuffle(this.randomNumbers);
    this.getPaymentDetails();
    this.setPaymentDetails(this.paymentDetails);
    this.isMakingPayment.emit("");
  }

  shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  loadScripts() {
    // const dynamicScripts = ["../../../../assets/daga.js"];
    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement("script");
    //   node.src = dynamicScripts[i];
    //   node.type = "text/javascript";
    //   node.async = false;
    //   node.charset = "utf-8";
    //   document.getElementsByTagName("head")[0].appendChild(node);
    // }
  }

  configuration = {
    fields: {
      cardNumber: {
        selector: "#cardNumber-container",
        placeholder: "****  ****  ****  ****",
        styles: {
          "caret-color": "#e26210",
          "font-size": "1em",
          "font-family": "inherit",
          "border-radius": "8px",
          cursor: "text",
          height: "50px",
          padding: "5px 0px 0px 10px",
          background: "#f0f0f0 0% 0% no-repeat padding-box",
          border: "0",
        },
      },
      expirationDate: {
        selector: "#expirationDate-container",
        placeholder: "MM / YY",
        styles: {
          "caret-color": "#e26210",
          "font-size": "1em",
          "font-family": "inherit",
          "border-radius": "8px",
          cursor: "text",
          height: "50px",
          padding: "5px 0px 0px 10px",
          background: "#f0f0f0 0% 0% no-repeat padding-box",
          border: "0",
        },
      },
      cvv: {
        selector: "#cvv-container",
        placeholder: "***",
        styles: {
          "caret-color": "#e26210",
          "font-size": "1em",
          "font-family": "inherit",
          "border-radius": "8px",
          cursor: "text",
          height: "50px",
          padding: "5px 0px 0px 10px",
          background: "#f0f0f0 0% 0% no-repeat padding-box",
          border: "0",
        },
      },
      pin: {
        selector: "#pin-container",
        placeholder: "* * * *",
        styles: {
          "caret-color": "#e26210",
          "font-size": "1em",
          "font-family": "inherit",
          "border-radius": "8px",
          padding: "0",
          cursor: "text",
          height: "50px",
          "padding-left": "10px",
          background: "#f0f0f0 0% 0% no-repeat padding-box",
          border: "0",
        },
      },
      otp: {
        selector: "#otp-container",
        placeholder: "* * * * * *",
        styles: {
          "caret-color": "#e26210",
          "font-size": "1em",
          "font-family": "inherit",
          "border-radius": "8px",
          padding: "0",
          cursor: "text",
          height: "50px",
          "padding-left": "10px",
          background: "#f0f0f0 0% 0% no-repeat padding-box",
          border: "0",
        },
      },
    },
    cardinal: {
      containerSelector: ".cardinal-container",
      activeClass: "show",
    },
    paymentParameters: {
      amount: 0,
      currencyCode: "566",
      dateOfPayment: new Date().toISOString(),
      payableCode: environment.payableCode,
      merchantCustomerName: "Global Accelerex Web PG",
      merchantCode: environment.merchantCode,
      transactionReference: "",
    },
  };

  showFormErrors = false;
  focusedField;

  setDoms() {
    var payga = this;
    document.getElementById("loaderMan").style.display = "block";
    document.getElementById("noCardOption").style.display = "none";
    document.getElementById("isStatusCheck").style.display = "none";
    document.getElementById("main").style.display = "none"; //ensure fields are return from isw before you display fields
    var instance;
    var payButton = document.getElementById("pay-button");
    var continueButton = document.getElementById("continue-button");
    var validateButton = document.getElementById("validate-button");
    var pinBackButton = document.getElementById("pin-back-button");
    var otpBackButton = document.getElementById("otp-back-button");

    let GA_isw_response = document.getElementById("iswResponse");
    let mainPage = document.getElementById("cardPayment");
    let loaderPage = document.getElementById("loaderMan");

    pinBackButton.addEventListener("click", function () {
      setActivePage("card-details");
      instance.clearField("pin");
    });

    otpBackButton.addEventListener("click", function () {
      setActivePage.bind(this, "pin");
      instance.clearField("otp");
    });

    function setActivePage(pageName) {
      document.getElementById("loaderMan").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("main").style.display = "block";
      let pages = document.querySelectorAll(".form-page");
      for (let i = 0; i < pages.length; i++) {
        let page = pages[i];
        page.classList.remove("show");
      }

      let activePage = document.querySelector(".form-page." + pageName);
      activePage.classList.add("show");
    }

    function createHandler(createError, hostedFieldsInstance) {
      if (document.getElementById("noCardOption").style.display == "block") {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("isStatusCheck").style.display = "none";
        document.getElementById("main").style.display = "none";
        return;
      }
      document.getElementById("loaderMan").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("isStatusCheck").style.display = "none";
      document.getElementById("main").style.display = "block";
      if (createError != null) {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        throw createError;
      }

      instance = hostedFieldsInstance;

      instance.on("focus", function (event) {
        let fieldContainer = document.querySelector(event.selector);
        fieldContainer.style.borderBottomColor = "#a0c8e2";
      });

      instance.on("blur", function (event) {
        let fieldContainer = document.querySelector(event.selector);
        fieldContainer.style.borderBottomColor = "#e4e4e4";
      });

      instance.on("validation", function (event) {});

      instance.on("cardinal-response", handleCardinalValidateResponse);

      payButton.addEventListener("click", function () {
        instance.getBinConfiguration(handleBinConfigResponse);
      });

      continueButton.addEventListener("click", async function () {
        document.getElementById("loaderMan").style.display = "block";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "none";
        payga
          .RegisterPaymentDetails()
          .then((res) => {
            instance.makePayment(handlePayResponse);
          })
          .catch(() => {
            payga.checkPaymentStatus();
          });
      });

      validateButton.addEventListener("click", function () {
        document.getElementById("loaderMan").style.display = "block";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "none";
        instance.validatePayment(handleValidateResponse);
      });

      //wait untill page is initialise
      // document.getElementById("loaderMan").style.display = "none";
      // document.getElementById("main").style.display = "block";

      // setTimeout(() => {
      //   document.getElementById("loaderMan").style.display = "none";
      //   document.getElementById("isStatusCheck").style.display = "none";
      //   document.getElementById("main").style.display = "block";
      // }, 6200);
    }
    setTimeout(() => {
      if (document.getElementById("loaderMan").style.display != "none") {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("isStatusCheck").style.display = "none";
        document.getElementById("main").style.display = "none";
        document.getElementById("noCardOption").style.display = "block";
        return;
      }
    }, 30000);
    isw.hostedFields.create(this.configuration, createHandler);

    // payButton.addEventListener("click", function () {
    //   instance.getBinConfiguration(handleBinConfigResponse);
    // });

    function handleCardinalValidateResponse(err, response) {
      setActivePage("card-details");
      if (err != null && err.validationError === true) {
        showNotification(err, null);
      }

      if (err != null) {
        showNotification(err, null);
      }

      if (response.responseCode === "00") {
        payga.checkPaymentStatus();
        return;
      }
    }

    function handleBinConfigResponse(err, response) {
      loadingMessage = "Validating Card details";
      document.getElementById("loaderMan").style.display = "block";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("main").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";

      if (err != null && err.validationError === true) {
        let fieldContainer = document.getElementById("cardNumber-container");
        fieldContainer.style.borderBottomColor = "#FF0000";
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "block";
        return;
      }
      if (err != null && err.networkError === true) {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "block";
        showNotification(err, null);
        return;
      }
      if (err !== null) {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "block";
        showNotification(err, null);
        return;
      }

      if (response.supportsPin) {
        document.getElementById("loaderMan").style.display = "none";
        document.getElementById("noCardOption").style.display = "none";
        document.getElementById("main").style.display = "block";
        setActivePage("pin");
        return;
      }

      // instance.makePayment(handlePayResponse);
      payga
        .RegisterPaymentDetails()
        .then((res) => {
          instance.makePayment(handlePayResponse);
        })
        .catch(() => {
          payga.checkPaymentStatus();
        });
    }

    function showNotification(error, response) {
      document.getElementById("loaderMan").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("isStatusCheck").style.display = "none";
      document.getElementById("main").style.display = "block";
      if (response) {
        let responseCode = response.responseCode;
        if (response.plainTextSupportMessage) {
          iswResponseCode.value = response.plainTextSupportMessage;
          setResponseMessages(null, iswResponseCode.value);
        } else {
          iswResponseCode.value = responseCode;
          setResponseMessages(responseCode);
        }
      } else if (error) {
        let errorCode = error.responseCode;
        let validationError = error.validationError;
        let networkError = error.networkError;
        if (validationError) {
          iswResponseCode.value = "Card Validation Error";
          setResponseMessages(null, iswResponseCode.value);
        }
        if (networkError) {
          iswResponseCode.value = "Network Error";
          setResponseMessages(null, iswResponseCode.value);
        }
        if (errorCode) {
          iswResponseCode.value = errorCode;
          setResponseMessages(iswResponseCode.value);
        } else {
          iswResponseCode.value = "Internal Server Error, Try Again Later";
          setResponseMessages(null, "Internal Server Error, Try Again Later");
        }
      }
      if (response.responseCode == "00") {
        payga.checkPaymentStatus();
        return;
      }
    }

    function handlePayResponse(err, response) {
      document.getElementById("loaderMan").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("main").style.display = "block";
      if (err != null && err.validationError === true) {
        showNotification(err, response);
        return;
      }

      if (err != null && err.networkError === true) {
        //we can restat txn if network error. or check status
        //check if the transaction was successful by mistake
        payga.checkPaymentStatus();
        return;
      }

      if (err != null) {
        showNotification(err, null);
        return;
      }

      if (response.requiresCentinelAuthorization === true) {
        setActivePage("cardinal");
        return;
      }

      if (response.responseCode === "T0") {
        setActivePage("otp");
        return;
      }
      if (response.responseCode === "00") {
        payga.checkPaymentStatus();
        return;
      } else {
        payga.checkPaymentStatus();
        return;
      }
    }

    function handleValidateResponse(err, response) {
      if (err != null && err.validationError === true) {
        showNotification(err, null);
        return;
      }

      if (err != null && err.networkError === true) {
        showNotification(err, null);
        return;
      }

      if (err != null) {
        showNotification(err, null);
        return;
      }

      if (response) {
        showNotification(null, response);
        return;
      }
    }

    // set the message display for a few seconds  GA implementation
    function setResponseMessages(responseCode, message?) {
      document.getElementById("main").style.display = "none";
      let GAsystemErrors = ["Z81", "XS1", "Z1", "91", "T1"];
      // let GAnonSystemErrors = ["56", "55", "54", "X03", "Z5"];
      if (message) {
        payga.checkPaymentStatus();
        return;
      } else {
        if (responseCode == "00") {
          // GA_isw_response.classList.add("successResponse");
          payga.checkPaymentStatus();
          return;
        }
        // if (responseCode == "T0" || responseCode == "T1") {
        if (responseCode == "T0") {
          document.getElementById("main").style.display = "block";
          GA_isw_response.classList.add("systemErrors");
          setTimeout(function () {
            GA_isw_response.classList.remove("systemErrors");
          }, 3000);
          return;
        } else {
          // GA_isw_response.classList.add("errorReponse");
          payga.checkPaymentStatus();
          return;
        }
      }
    }
  }

  iswPaymentRef = "";
  getPaymentDetails() {
    if (!this.paymentDetails.amount) {
      this.route.navigate([
        `/failure/0/${this.paymentDetails.referenceId}/${btoa(
          this.paymentDetails.callbackURL
        )}`,
      ]);
      return;
    }
    this.configuration.paymentParameters.amount = this.setAmountWithKobo(
      this.paymentDetails.amount
    );
    this.iswPaymentRef = `${this.paymentDetails.referenceId}__${this.paymentDetails.clientId}`;
    this.configuration.paymentParameters.transactionReference = this.iswPaymentRef;
    // else {
    this.setDoms();
    this.checkIfPageIsLoadedPreviously.value = 1;
    // }
  }

  setAmountWithKobo(amount) {
    amount = Number(amount).toFixed(2);
    amount = String(amount).replace(".", "");
    return Number(amount);
  }

  setPaymentDetails(details) {
    this.cardpaymentreq.reference = details.referenceId;
    this.cardpaymentreq.clientId = details.clientId;
    this.cardpaymentreq.userId = details.userId;
    this.cardpaymentreq.paymentUrl = details.paymentUrl;
    this.cardpaymentreq.amount = details.amount;
    this.cardpaymentreq.currency = details.currency;
    this.cardpaymentreq.callbackUrl = details.notificationUrl;
    this.cardpaymentreq.paymentChannel = "CARD";
  }

  checkPaymentStatus() {
    document.getElementById("main").style.display = "none";
    document.getElementById("isStatusCheck").style.display = "none";
    document.getElementById("loaderMan").style.display = "block";
    document.getElementById("noCardOption").style.display = "none";
    this.payservice
      .checkPaymentStatus(
        this.cardpaymentreq.clientId,
        this.cardpaymentreq.reference
      )
      .subscribe(
        async (data) => {
          document.getElementById("loaderMan").style.display = "none";
          document.getElementById("noCardOption").style.display = "none";
          document.getElementById("main").style.display = "none";
          document.getElementById("isStatusCheck").style.display = "block";
          await this.setResponseMessage(data["status"]);
        },
        (error) => {
          document.getElementById("loaderMan").style.display = "none";
          document.getElementById("noCardOption").style.display = "none";
          document.getElementById("main").style.display = "none";
          document.getElementById("isStatusCheck").style.display = "block";
          this.GA_paymentResponse.value = "Transaction ongoing ..";
          let GA_isw_response = document.getElementById("iswResponse");
          GA_isw_response.classList.add("errorReponse");
          document.getElementById("loaderMan").style.display = "none";
          document.getElementById("noCardOption").style.display = "none";
          document.getElementById("isStatusCheck").style.display = "block";
          setTimeout(function () {
            GA_isw_response.classList.remove("errorReponse");
          }, 3000);
          return;
        }
      );
  }

  //make payment endpoint
  RegisterPaymentDetails(): any {
    document.getElementById("loaderMan").style.display = "block";
    document.getElementById("noCardOption").style.display = "none";
    document.getElementById("main").style.display = "none";
    return new Promise((res, rej) => {
      this.payservice.makePayment(this.cardpaymentreq).subscribe(
        async (data) => {
          this.isMakingPayment.emit("card");
          let resp = "success";
          res(resp);
          // document.getElementById("loaderMan").style.display = "none";
          // document.getElementById("main").style.display = "block";
        },
        (error) => {
          this.route.navigate([
            `/failure/${this.paymentDetails.amount}/${
              this.paymentDetails.referenceId
            }/${btoa(this.paymentDetails.callbackURL)}`,
          ]);
          rej();
        }
      );
    });
  }

  setResponseMessage(response) {
    let GA_isw_response = document.getElementById("iswResponse");
    if (response == "ONGOING" || response == "CREATED") {
      this.GA_paymentResponse.value = `Transaction ${response}`;
      GA_isw_response.classList.add("errorReponse");
      document.getElementById("loaderMan").style.display = "none";
      document.getElementById("noCardOption").style.display = "none";
      document.getElementById("main").style.display = "none";
      document.getElementById("isStatusCheck").style.display = "block";
      setTimeout(function () {
        GA_isw_response.classList.remove("errorReponse");
      }, 3000);
      return;
    }
    if (response == "FAILED" || response == "ABANDONED") {
      this.route.navigate([
        `/failure/${this.paymentDetails.amount}/${
          this.paymentDetails.referenceId
        }/${btoa(this.paymentDetails.callbackURL)}`,
      ]);
      return;
    }
    if (response == "SUCCESS") {
      let callbackUrl = this.paymentDetails.callbackURL
        ? this.paymentDetails.callbackURL
        : "empty";
      this.route.navigate([
        `/checkout/success/${this.paymentDetails.amount}/${
          this.paymentDetails.referenceId
        }/${btoa(callbackUrl)}`,
      ]);
      return;
    } else {
      this.route.navigate([
        `/failure/${this.paymentDetails.amount}/${
          this.paymentDetails.referenceId
        }/${btoa(this.paymentDetails.callbackURL)}`,
      ]);
      return;
    }
  }
}
